/**
 * Activity List
 */
$(document).on("ready", function () {
  $(document).on("click", ".actType", function () {
    var which = $(this).attr("id");
		console.log('type of activity2: ' + $(this).attr('id'))
    setTypes(which);
  });
});

function setTypes(which) {
  "use strict";
  var $actType = $("#" + which);
  $actType.attr("data-val", $actType.val());
  $.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: {
      action:'fw_activity_detail',
      type: $actType.val(),
      id: $actType.data("ent-type"),
      detail: $actType.data("detail"),
      actname: $actType.data("name"),
    },
    dataType: "html",
    success: function (data) {
      $("#actDetail").html(data);
      /*
      $("#" + $actType.data("id") + "Name").on("change", function () {
        if ($(this).val() == "OTH") {
          var $oth = $("#" + $actType.data("id") + "Other").clone();
          console.log("#" + $actType.data("id") + "Other");
          $oth.attr("type", "text");
          $("#" + $actType.data("id") + "Other").remove();
          $oth.insertAfter($(this));
        }
      });
       */
    },
    error: function (xhr, desc, err) {
      console.log(xhr);
      console.log("Details0: " + desc + "\nError:" + err);
    },
  });
}
